import {useState} from "react";
import useAppContext from "lib/hooks/use-app-context";
import Form from "./form";
import Surveys from "./surveys";

export default function SignUp() {
  const {app: {organization}} = useAppContext();
  const [surveyID, setSurveyID] = useState(organization.deck_id);

  if(surveyID) { return <Form surveyID={surveyID} />; }

  return <Surveys setSurveyID={setSurveyID} />;
}
